// extracted by mini-css-extract-plugin
export default {"dot":"HalfDoughnutWidget_dot__wwica"};